import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from '../Flex';
import { DrawerMenu } from '../Drawer';

function Page({ list, children }) {
  return (
    <Flex direction="row" minHeight="100vh" maxHeight="100vh">
      <DrawerMenu list={list} />
      <Flex minHeight="100vh" flexGrow={1}>
        {children}
      </Flex>
    </Flex>
  );
}

Page.defaultProps = {
  list: {},
  children: null,
};

Page.propTypes = {
  list: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
};

export { Page };
